import { Cores } from 'src/componentes/styles/cores'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const Cabecalho = styled.div`
  margin-bottom: 16px;
`

export const Icone = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 22px;
    height: 22px;
  }
`

export const ContainerConteudo = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 720px;
  margin: 0 auto;
  padding: 24px 0;

  > h2 {
    font-size: 18px;
    color: ${Cores.PRIMARIA_1};
    margin-bottom: 16px;
  }

  > p {
    font-size: 16px;
    color: ${Cores.CINZA_1};
    line-height: 1.6;
    margin-bottom: 12px;
  }

  > ul {
    margin: 0 0 16px 20px;

    li {
      font-size: 14px;
      color: ${Cores.CINZA_1};
      line-height: 1.6;
      margin-bottom: 8px;
      list-style: disc;
      display: list-item;
    }
  }
`

export const ContainerModalCancelar = styled.div`
  display: flex;
  flex-direction: column;
  width: 460px;
  max-width: 90vw;
  padding: 28px 32px;

  > h2 {
    font-size: 18px;
    color: ${Cores.PRIMARIA_1};
    margin-bottom: 8px;
  }

  > p {
    font-size: 14px;
    color: ${Cores.CINZA_1};
    line-height: 1.5;
    margin-bottom: 20px;
  }

  textarea {
    width: 100%;
  }
`

export const ContainerCheckbox = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 20px 0;

  label {
    font-family: 'Saira', sans-serif;
    font-size: 14px;
    line-height: 1.4;
    color: ${Cores.CINZA_2};
    cursor: pointer;
  }
`

export const ContainerAcoes = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-top: 24px;
`

export const CaixaValores = styled.div`
  border: 1px solid ${Cores.CINZA_3};
  border-radius: 8px;
  padding: 16px;
  margin: 16px 0;

  div.linha {
    display: flex;
    justify-content: space-between;
    padding: 8px 0;
    border-bottom: 1px solid ${Cores.CINZA_3_CLARO};

    &:last-child {
      border-bottom: none;
    }

    &.total {
      font-weight: 700;
      color: ${Cores.PRIMARIA_1};
      font-size: 16px;
    }
  }
`

export const ContainerPDFViewer = styled.div`
  width: 100%;
  margin: 16px 0;
`

// Tela do termo de rescisão precisa de mais espaço que o restante do fluxo de rescisão
// (textos corridos, max-width: 720px) para o PDF ficar legível — mesmo espírito da tela de
// Termos e Condições da matrícula, que usa a largura cheia do layout.
export const ContainerConteudoTermo = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 960px;
  margin: 0 auto;
  padding: 24px 0;

  > h2 {
    font-size: 28px;
    color: ${Cores.PRIMARIA_1};
    margin-bottom: 16px;
  }
`
